import store from '@/store/index'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const AppModule = namespace('app')

const { body } = window.document
const WIDTH = 1024
const RATIO = 3

// You can declare a mixin as the same style as components.
@Component
export default class ResizeMixin extends Vue {
  public device: string = ''
  @AppModule.Getter
  public sidebar!: { opened: boolean, withoutAnimation: boolean }
  // public sidebar: {opened: boolean, withoutAnimation: boolean} = { opened : true, withoutAnimation: false}

  @Watch('$route')
  public onRouteChange(route: any) {
    if (this.device === 'mobile' && this.sidebar.opened) {
      store.dispatch('app/CloseSideBar', { withoutAnimation: false })
    }
  }

  public beforeMount() {
    window.addEventListener('resize', this.resizeHandler)
  }
  public mounted() {
    const isMobile = this.isMobile()
    if (isMobile) {
      store.dispatch('app/ToggleDevice', 'mobile')
      store.dispatch('app/CloseSideBar', { withoutAnimation: true })
    }
  }

  public isMobile() {
    const rect = body.getBoundingClientRect()
    return rect.width - RATIO < WIDTH
  }
  public resizeHandler() {
    if (!document.hidden) {
      const isMobile = this.isMobile()
      store.dispatch('app/ToggleDevice', isMobile ? 'mobile' : 'desktop')
      if (isMobile) {
        store.dispatch('app/CloseSideBar', { withoutAnimation: true })
      }
    }
  }
}
